import { render, staticRenderFns } from "./SithMesPrdPpComponentEdit.vue?vue&type=template&id=5d0f5bc8&"
import script from "./SithMesPrdPpComponentEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdPpComponentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports